const CM = {
  ibanLength: 27,
};
export { CM };
